import moment from 'moment/moment'

export const formatAmounts = (amount, decimal = true) => {
    if (amount) {
        return decimal ? '$' + parseFloat(amount / 100).toFixed(2) : '$' + parseFloat(amount / 100).toFixed(0)
    } else {
        return '-'
    }
}

export const formatCurrency = (amount) => {
    if (amount) {
        return '$' + parseFloat(amount).toFixed(2)
    } else {
        return '-'
    }
}

export const formatDate = (timestamp) => {
    if (timestamp) {
        return moment.utc(timestamp).local().format('MM/DD/YYYY, h:mma')
    } else {
        return '-'
    }
}

export const isValidDateUnix = (timestamp) => {
    return moment.unix(timestamp).isValid()
}

export const formatDateUnix = (timestamp) => {
    if (timestamp) {
        return moment.unix(timestamp).local().format('MMMM Do YYYY [at] h:mm a')
    } else {
        return '-'
    }
}

export const formatDateNoHour = (timestamp) => {
    if (timestamp) {
        return moment.utc(timestamp).local().format('MM/DD/YYYY')
    } else {
        return '-'
    }
}

export const formatHour = (timestamp) => {
    if (timestamp) {
        return moment.utc(timestamp).local().format('h:mma')
    } else {
        return '-'
    }
}

export const formatSessionState = (state) => {
    if (state) {
        return state.charAt(0).toUpperCase() + state.slice(1)
    } else {
        return '-'
    }
}


export const isEmpty = (obj) => {
    return obj && Object.keys(obj).length === 0;
};

export function formatAddress(p = {}, opts = {}) {
    const { multiline = false } = opts;

    const clean = (s) =>
        (s ?? '').toString().trim().replace(/\s{2,}/g, ' ');

    const a1 = clean(p.address1);
    const a2 = clean(p.address2);
    const city = clean(p.city);
    const state = clean(p.state);
    const zip = clean(p.zipcode);

    const line1 = [a1, a2].filter(Boolean).join(' ');
    const region = [state, zip].filter(Boolean).join(' ');
    const line2 = [city, region].filter(Boolean).join(', ');

    const parts = [line1, line2].filter(Boolean);
    return multiline ? parts.join('\n') : parts.join(', ');
}

export function parseGPEVChargeLink(input) {
    const parts = input.split(',')
    if (parts.length < 3) throw new Error('Invalid GPEV QR format')
    const [serial, model, macAddress, dateOfManufacture = ''] = parts.map(p => p.trim())
    const macRe = /^([0-9a-fA-F]{2}:){5}[0-9a-fA-F]{2}$/
    if (!macRe.test(macAddress)) throw new Error('Invalid MAC address in QR code')
    return { serial, model, macAddress, dateOfManufacture }
}

export function parseChargeLink(input) {
    const url = input.startsWith('http') ? new URL(input) : new URL(input, window.location.origin);
    const params = url.searchParams;

    const deviceId = params.get('device') || '';
    const model = params.get('model') ? decodeURIComponent(params.get('model')) : '';

    // Basic RFC 4122 UUID v1–v5 check
    const uuidRe = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (!uuidRe.test(deviceId)) {
        throw new Error('Invalid or missing device UUID');
    }
    if (!model) {
        throw new Error('Missing model');
    }

    return { deviceId, model };
}

export const uuid4 = () =>
    (crypto.randomUUID ? crypto.randomUUID() : require('uuid').v4());

export const nowPlusHoursUnix = (hours = 0) =>
    Math.floor((Date.now() + hours * 3600_000) / 1000);


export function getChargingPowerTypeDisplay(type, powerType, peakWatts) {
    return type === 1
        ? `120V - ${peakWatts}kW AC` // L1 display 120V
        : `${powerType === '1P-240' // L2 and powerType === 1P-240 display 240V
            ? '240V'
            : powerType === '3P-208' // else  L2 and powerType === 3P-208 display 208V
                ? '208V'
                : 'L2' // fallback L2 in case powerType not there or doesn't match the above
        } - ${peakWatts}kW AC`
} 
// "YEAR MAKE MODEL", skipping blanks and repeated words (AUX vehicles come back as year 0, make "AUX", model "aux").
export const vehicleLabel = (vehicle) => {
    const parts = []
    ;[Number(vehicle?.year) ? vehicle.year : null, vehicle?.make, vehicle?.model].forEach((part) => {
        const value = part == null ? '' : String(part).trim()
        if (value && !parts.some((p) => p.toLowerCase() === value.toLowerCase())) parts.push(value)
    })
    return parts.join(' ').toUpperCase()
}

// Guest / CAR / UNKNOWN -> car, MOTORCYCLE -> motorcycle, AUX -> electrical.
export const vehicleIconName = (vehicle) => {
    if (vehicle?.type === 'AUX') return 'electrical'
    if (vehicle?.guest) return 'car'
    if (vehicle?.type === 'MOTORCYCLE') return 'motorcycle'
    return 'car'
}
